export enum AccountTypes {
  client = 'CLIENT',
  pilot = 'PILOT',
  company = 'COMPANY',
  admin = 'ADMIN',
}
